import { initialiseAgeGates } from "./components/age-gate";
import { initialiseHeroCarousels } from "./components/hero-carousel";
import { initialiseMobileMenus } from "./components/mobile-menu";

function initialiseWebsite() {
	initialiseAgeGates();
	initialiseHeroCarousels();
	initialiseMobileMenus();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initialiseWebsite);
} else {
	initialiseWebsite();
}
